import { formatDate } from '@angular/common';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { QuestionHelpText } from 'src/app/model/question-help-text';

@Component({
    selector: 'app-help-text',
    templateUrl: './help-text.component.html',
    encapsulation: ViewEncapsulation.None
})
export class HelpTextComponent implements OnInit {
    questionIds: number[] = [];

    constructor(public dialogRef: MatDialogRef<HelpTextComponent>, @Inject(MAT_DIALOG_DATA) public data: QuestionHelpText) {
        console.log("help text called with data:")
        console.log(data)
    }

    ngOnInit(): void {}

    onNoClick(): void {
        this.dialogRef.close();
    }
}
